var Promise = require('bluebird');


module.exports = {
  config: {
    target: {
      className: 'tour-highlight'
    }
  },
  steps: [{
    target: {
      triggerNextOn: 'click',
    },
    toast: {
      body: "You can add 'Funding Criteria' to automatically match funding applications to the requirements of your organisation.  Criteria such as 'Charitable Category' are available and are used to match the applicant's answers to your requirements",
      showNext: true,
    },
  },{
    target: {
      el: '#whatWeFundTab1',
      triggerNextOn: 'click',
    },
    toast: {
      body: 'Click on the "Capital/Revenue" tab',
    },
  },{
    target: {
      el: '#whatWeFundQuestions0 .question',
      triggerNextOn: 'click',
    },
    toast: {
      body: 'Click on a quesiton to edit',
    },
  },{
    target: {
      el: '#whatWeFundData',
    },
    toast: {
      body: 'Fill in the appropriate matching criteria and whether the criteria is mandatory. Continue until all your criteria have been entered. You do not have to add criteria for any of these questions.',
      showNext: true,
    },
  },{
    target: {
      el: '#whatWeFundTab2',
      triggerNextOn: 'click',
    },
    toast: {
      body: "Click on the 'Benefits' tab",
    },
  },{
    target: {
      el: '#whatWeFundData',
    },
    toast: {
      body: 'Fill in the appropriate matching criteria and whether the criteria is mandatory. Continue until all your criteria have been entered. You do not have to add criteria for any of these questions.',
      showNext: true,
    },
  },{
    target: {
      el: '#whatWeFundTab3',
      triggerNextOn: 'click',
    },
    toast: {
      body: "Click the 'Project Costs' tab",
    },
  },{
    target: {
      el: '#whatWeFundData',
    },
    toast: {
      body: "Fill in the appropriate matching criteria and whether the criteria is mandatory. Continue until all your criteria have been entered. Once complete, click the 'Finish' button.",
      closeText:'Finish',
    },
  }]
}
